import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import NextHydrationBoundary from "./NextHydrationBoundary.js";
import { getQueryClient } from "./queryClient.js";
const NextQueryProvider = (t0) => {
  const $ = c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const client = t1;
  let t2;
  if ($[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsx(ReactQueryDevtools, { initialIsOpen: false, buttonPosition: "bottom-right", position: "bottom" });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = /* @__PURE__ */ jsx(QueryClientProvider, { client, children: /* @__PURE__ */ jsxs(NextHydrationBoundary, { children: [
      children,
      t2
    ] }) });
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export {
  NextQueryProvider as default
};
